<template>
    <div>
        checkin completed
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
